(ns frontend.exports.exceljs.workbook
  (:require ["exceljs" :as exceljs]
            [clojure.string :as string]
            [frontend.logging :as logging]
            [goog.dom :as dom]
            [oops.core :as oops]))

(js/goog.exportSymbol "ExcelJS" exceljs)

(defn create-workbook []
  (js/ExcelJS.Workbook.))

(defn add-sheet [wb sheet-name]
  (.call (aget wb "addWorksheet") wb sheet-name))

(defn get-sheet [wb sheet-name]
  (oops/ocall! wb "getWorksheet" sheet-name))

(defn create-workbook-with-sheet [sheet-name]
  (let [wb (create-workbook)]
    [wb (add-sheet wb sheet-name)]))

(defn save-workbook [wb file-name]
  (let [xlsx (aget wb "xlsx")
        write-promise (.call (aget xlsx "writeBuffer") xlsx (clj->js {:base64 true}))]
    (-> write-promise
        (.then (fn [content]
                 ; build anchor tag and attach file (works in chrome)
                 (let [a (js/document.createElement "a")
                       data (js/Blob. (clj->js [content])
                                      (clj->js {:type "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
                       url (js/URL.createObjectURL data)]
                   (aset a "href" url)
                   (aset a "download" (if (string/ends-with? file-name ".xlsx")
                                        file-name
                                        (str file-name ".xlsx")))
                   (dom/appendChild (aget js/document "body") a)
                   (.call (aget a "click") a)
                   (js/setTimeout (fn []
                                    (dom/removeNode a)
                                    (js/URL.revokeObjectURL url))
                                  100))))
        (.catch #(logging/error "CATCH " %))
        (.finally
         (fn [_])))))

